import "../App.css";

export function Touch() {

    return <div id="get_in_touch">
        <div>Get In Touch</div>
        <div>I'm currently looking for full-time Software Engineering opportunities! If you know of any positions available, if you have any questions, or if you just want to say hi, please feel free to email me at, <a style={{ color: "blue" }} href="mailto:rv.ramendra1@gmail.com">rv.ramendra1@gmail.com</a>.</div>
        <div>Or, Message me at:</div>
        <div id="blacks">
            <a target="_blank" rel="noreferrer" href="https://github.com/rv-vikram"><i class="fab fa-github"></i></a>
            <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/itsrvsingh/"><i class="fab fa-linkedin"></i></a>
            <a target="_blank" rel="noreferrer" href="https://instagram.com/_its.rav_"><i class="fab fa-instagram"></i></a>
            <a target="_blank" rel="noreferrer" href="https://twitter.com/ramendravsingh"><i class="fab fa-twitter"></i></a>
        </div>
        <div style={{ marginTop: "1%" }}><i class="fas fa-code"></i> with <i class="fas fa-heart"></i> by <span id="last_name">Rv</span> using <i class="fab fa-react"></i></div>
    </div>
}